if (typeof globalThis === "undefined") {
  window.globalThis = window;
}
